import { route } from '@/ziggy-shim';
import { api, CastValue } from './LaravelClient';

export default {
  async search(projectId: Id, data: ApiRequests['api.v1.plant-categories.search'] = {}) {
    return await api(route('api.v1.plant-categories.search', projectId), 'get', {
      data,
      casts: {
        name: (value, clone, key) => new CastValue(value).cast('nullable', clone, key).get(),
      },
    });
  },

  async create(projectId: Id, data: ApiRequests['api.v1.plant-categories.store']) {
    return await api(route('api.v1.plant-categories.store', projectId), 'post', {
      data,
    });
  },

  async update(id: Id, data: ApiRequests['api.v1.plant-categories.update']) {
    return await api(route('api.v1.plant-categories.update', id), 'patch', {
      data,
    });
  },

  async delete(id: Id) {
    return await api(route('api.v1.plant-categories.destroy', id), 'delete');
  },
};
